import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
// eslint-disable-next-line no-unused-vars
// import { decryptByDES, decryptData } from "@/utils/index";
// let Base64 = require("js-base64").Base64;
let mes = "";
// const publicKey =
//   "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkmJMZAnwmus/FyrNc3zmll9krFaTbtS9f3mgpscdNAw3erlHGFyDq50DOf456B2SjzyY/21vhJfRpqu9FaiZAlZNZrY2/CtElKSWiNzYKBCaxl+hrSzlvhiWk4eEduHU4IKhLV6hjm5BloIIbbsyqO29WRsa4c7NG0gQKczUefUt2kj+KB5i0XBYCgNMV49+7ewhJ+YzsoL9CoL5oHspNubbHhoRFtknjuDdrJC4IcbXhPszIkPH6zfI1Wfd5qZ9YK+KDiMmKWwc7zw2s7zXBx3CQkFYCWASHhFmX13Pm06XfQVGKCWgs4CvG892wvImVJSYWIPslNYPEgM4DMuBfwIDAQAB-----END PUBLIC KEY-----";
// create an axios instance
const service = axios.create({
  baseURL: "/api", // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["token"] = getToken();
    }
    // config.data = JSON.stringify(config.data);
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const item = response.data;
    let res = null;
    res = item;
    if (res.code !== "20000" && res.type != "FeatureCollection") {
      if (mes) {
        mes.close();
      }
      mes = Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000
      });

      if (res.code === "1000" || res.code === "1222") {
        if (response.config.url === "/policySearch/list") {
          window.location.href = "/login";
        } else {
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
        }
      }
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      console.log(response);
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
